import { useState } from "react";
import { request } from "../../../request";
import CreatableSelect from "react-select/creatable";
import { Box, TextField, MenuItem, Button, Typography, Autocomplete, InputAdornment, Chip, IconButton, useMediaQuery, useTheme } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Swal from "sweetalert2";

const EditCustomer = ({ darkMode, customers, customerType, updateCustomers, edit, setEdit, texts }) => {
    const customer = customers.find((e) => e._id === edit);

    const [customerName, setCustomerName] = useState(customer.name);
    const [customerContact, setCustomerContact] = useState(customer.contact);
    const [customerComment, setCustomerComment] = useState(customer.comment);
    const [selectedCustomerType, setSelectedCustomerType] = useState(customer.type);

    const createCustomerType = async (newType) => {
        const label = newType ? newType : null;
        setSelectedCustomerType(label);
        await request.post("/customer/type", {
            type: newType,
        });
        updateCustomers();
    };

    const handleSubmit = async () => {
        try {
            await request.post("/customer/edit/" + edit, {
                name: customerName,
                contact: customerContact,
                comment: customerComment,
                type: selectedCustomerType,
            });
            Swal.fire({
                title: "Customer added successfully",
                icon: "success",
            });
            setCustomerContact("");
            setCustomerName("");
            setCustomerComment("");
            setSelectedCustomerType("");
            updateCustomers();
            setEdit(null);
        } catch (error) {
            Swal.fire({
                title: "Customer hasen't been updated",
                icon: "error",
            });
            console.log(error);
        }
    };

    const options = customerType.map((option) => ({
        value: option._id,
        label: option.type,
    }));

    return (
        <div>
            <div
                className="container p-6 mx-auto max-w-[900px] border-gray-300 rounded-lg shadow-lg"
                style={{
                    backgroundColor: darkMode ? "#000" : "white",
                    borderRadius: "20px",
                }}
            >
                <form className="mb-4" onSubmit={handleSubmit} style={{ border: "1px solid white", padding: "30px", borderRadius: "20px" }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <Typography variant="h5" sx={{ color: "white" }}>
                            {texts.customer.editCustomer}
                        </Typography>
                        <IconButton onClick={() => setEdit(null)}>
                            <CancelIcon sx={{ fontSize: "34px", color: "white" }} />
                        </IconButton>
                    </Box>
                    <div className="flex flex-col mb-4">
                        <label
                            className="text-lg mb-2"
                            htmlFor="name"
                            style={{
                                color: darkMode ? "white" : "black",
                            }}
                        >
                            {texts.customer.customerName}
                        </label>
                        <input type="text" id="name" value={customerName} onChange={(e) => setCustomerName(e.target.value)} className="border p-2 rounded" placeholder={texts.customer.enterCustomerName} required />
                    </div>
                    <div className="flex flex-col mb-4">
                        <label
                            className="text-lg mb-2"
                            htmlFor="value"
                            style={{
                                color: darkMode ? "white" : "black",
                            }}
                        >
                            {texts.customer.customerContact}
                        </label>
                        <input type="text" id="contact" value={customerContact} onChange={(e) => setCustomerContact(e.target.value)} className="border p-2 rounded" placeholder={texts.customer.enterCustomerContact} required />
                    </div>
                    <div className="flex flex-col mb-4">
                        <label
                            className="text-lg mb-2"
                            htmlFor="name"
                            style={{
                                color: darkMode ? "white" : "black",
                            }}
                        >
                            {texts.customer.addComment}
                        </label>
                        <input type="text" id="comment" value={customerComment} onChange={(e) => setCustomerComment(e.target.value)} className="border p-2 rounded" placeholder={texts.customer.enterComment} />
                    </div>
                    <CreatableSelect
                        isClearable
                        options={options}
                        onChange={(selectedOption) => {
                            const label = selectedOption ? selectedOption.label : null;
                            setSelectedCustomerType(label);
                        }}
                        onCreateOption={(newOption) => {
                            createCustomerType(newOption);
                        }}
                        value={selectedCustomerType ? { label: selectedCustomerType, value: selectedCustomerType } : ""}
                        styles={{
                            control: (base) => ({
                                ...base,
                                borderColor: "gray",
                                borderRadius: "0.375rem",
                                padding: "0.375rem",
                                boxShadow: "none",
                                "&:hover": { borderColor: "blue" },
                            }),
                            option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected ? "blue" : state.isFocused ? "lightgray" : "white",
                                color: state.isSelected ? "white" : "black",
                                "&:hover": {
                                    backgroundColor: "lightblue",
                                },
                            }),
                            menu: (base) => ({
                                ...base,
                                marginTop: 0,
                                borderRadius: "0.375rem",
                            }),
                            placeholder: (base) => ({
                                ...base,
                                color: "gray",
                                fontSize: "0.875rem",
                            }),
                        }}
                        placeholder={texts.customer.selectOrCreateUserType}
                    />
                    <button
                        type="submit"
                        className="flex min-w-[84px] max-w-[480px] mt-4 cursor-pointer items-center justify-center overflow-hidden rounded-xl h-10 px-4 bg-gray-200 text-[#111418] text-sm font-bold leading-normal tracking-[0.015em]"
                        style={{
                            backgroundColor: darkMode ? "#FEC901" : "#FEC901",
                        }}
                    >
                        {texts.customer.addUser}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default EditCustomer;
